import React, { useState } from "react";
import Nav from "./nav";
import img from "../assets/mb.jpg";
import img2 from "../assets/mob.jpg";
import kobi from "../../../../assets/images/KUUL TRANS ROUND.png";
import whatsapp from "../../../../assets/images/WhatsApp.png";
import { useNavigate } from "react-router-dom";
import ChatButton from "../../../../components/cards/message-card/chatButton";
import { FloatButton } from "antd";
import ChatInterface from "../../../../components/sections/chatai";

declare global {
  interface Window {
    ebanqo_widget: any;
  }
}

export default function Header() {
  const navigate = useNavigate();
  const [isChatOpen, setIsChatOpen] = useState(false);

  return (
    <>
      {/* DESKTOP SCREEN  */}
      <header
        className="w-full lg:block hidden xl:h-screen min-h-[50vh] bg-cover bg-center p-4 bg-no-repeat"
        style={{ backgroundImage: `url(${img})` }}
      >
        <Nav className="fixed top-0 right-0 z-50 bg-white/90 backdrop-blur-md" />

        <div className="  mt-32 ml-16  min-h-[40vh]">
          <p className=" text-8xl font-bold ">Healthcare</p>
          <p className=" text-8xl font-bold ">That </p>
          <p className=" text-8xl font-bold ">Comes to </p>
          <p className=" text-8xl font-bold ">
            <span className="text-blue-500 mr-5">You</span>
            on
          </p>
          <p className=" text-8xl font-bold  ">your </p>
          <p className=" text-8xl font-bold "> Schedule</p>
        </div>
      </header>

      {/* IPAD MINI AND SURFACE PRO7  */}
      <header
        className="w-full sm:block lg:hidden hidden min-h-[50vh] bg-cover bg-center p-4"
        style={{ backgroundImage: `url(${img2})` }}
      >
        <Nav className="fixed top-0 right-0 z-50 bg-white/90 backdrop-blur-md" />
        <div className="medium-view   flex justify-between items-center my-8 w-full min-h-[40vh] ">
          <div className="p-4 md:w-[40%] w-[50%]">
            <h1 className="xl:text-7xl lg:text-6xl md:text-6xl sm:text-5xl text-4xl text-black font-bold">
              Healthcare That Comes to You on your Schedule.
            </h1>
          </div>
        </div>
      </header>

      {/* MOBILE SCREEN  */}
      <header
        className="w-full sm:hidden bg-cover h-[50vh] bg-center p-2"
        style={{ backgroundImage: `url(${img2})` }}
      >
        <Nav className="fixed top-0 right-0 z-50 bg-white/90 backdrop-blur-md" />

        <div className=" mt-20 ml-2">
          <p className=" text-black font-bold text-xl">Healthcare</p>
          <p className=" text-black font-bold text-xl">That Comes To</p>
          <p className=" text-black font-bold text-xl">
            {" "}
            <span className="text-blue-500 mr-1.5">You</span>
            On Your{" "}
          </p>
          <p className=" text-black font-bold text-xl">Schedule</p>
        </div>
        <div className=" mt-10">
          <button
            onClick={() => navigate("/sign-up")}
            className="bg-[#FFCC08] px-8 py-2 cursor-pointer rounded-full"
          >
            Register
          </button>
        </div>
      </header>

      <div className="fixed bottom-10 -right-2 z-[9999] transform scale-150 flex items-center ">
        <FloatButton.Group
          trigger="click"
          type="default"
          style={{ insetInlineEnd: 24 }}
          icon={
            <img
              src={whatsapp}
              alt="WhatsApp"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          }
        >
          <FloatButton
            icon={
              <img
                src={whatsapp}
                alt="WhatsApp"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            }
            onClick={() =>
              window.open(
                "https://wa.me/233555061412?text=Hello%20Medpharma%20Team%2C%20I%20need%20assistance",
                "_blank",
                "noopener,noreferrer"
              )
            }
          />
          <FloatButton
            icon={<img src={kobi} alt="kobikull" />}
            // description="Ask Kobikuul, your health bot"

            onClick={() => setIsChatOpen(true)}
          />
        </FloatButton.Group>
      </div>

      <ChatButton />

      {/* Modal */}
      {isChatOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[10000]">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6 relative">
            <button
              onClick={() => setIsChatOpen(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            >
              ✖
            </button>
            <ChatInterface />
          </div>
        </div>
      )}
    </>
  );
}
